import { Button, FAIcon, Tooltip } from '@/components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { useState } from 'react'
import { downloadFile } from '@/utils/file'

interface DownloadFileButtonProps {
  url?: string | null
  fileName?: string | null
}

export const DownloadFileButton: React.FC<DownloadFileButtonProps> = ({
  url,
  fileName,
}) => {
  const translations = useTranslate({ download: 'common.download' })
  const [downloading, setDownloading] = useState(false)

  const handleDownload = async () => {
    if (!url) return
    try {
      setDownloading(true)
      await downloadFile(url, fileName ?? undefined)
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Tooltip content={translations.download}>
      <Button
        variant="ghost"
        size="icon-md"
        aria-label={translations.download}
        disabled={!url || downloading}
        onClick={handleDownload}
      >
        <FAIcon
          icon={downloading ? 'spinner' : 'download'}
          className={downloading ? 'fa-spin' : undefined}
        />
      </Button>
    </Tooltip>
  )
}
